import elementsBoxModel from '../elementsBoxModel'

const onResize = (el, name) => {
  const boundingClientRect = el.getBoundingClientRect()
  const boundingClientRectParent = el.parentElement.getBoundingClientRect()
  const getComputedStyle = window.getComputedStyle(el)
  const getComputedStyleParent = window.getComputedStyle(el.parentElement)

  elementsBoxModel[name] = {
    width: boundingClientRect.width,
    height: boundingClientRect.height,
    paddingTop: parseInt(getComputedStyle.getPropertyValue('padding-top')),
    paddingRight: parseInt(getComputedStyle.getPropertyValue('padding-right')),
    paddingBottom: parseInt(getComputedStyle.getPropertyValue('padding-bottom')),
    paddingLeft: parseInt(getComputedStyle.getPropertyValue('padding-left')),
    marginTop: parseInt(getComputedStyle.getPropertyValue('margin-top')),
    marginRight: parseInt(getComputedStyle.getPropertyValue('margin-right')),
    marginBottom: parseInt(getComputedStyle.getPropertyValue('margin-bottom')),
    marginLeft: parseInt(getComputedStyle.getPropertyValue('margin-left')),
    parent: {
      width: boundingClientRectParent.width,
      height: boundingClientRectParent.height,
      paddingTop: parseInt(getComputedStyleParent.getPropertyValue('padding-top')),
      paddingRight: parseInt(getComputedStyleParent.getPropertyValue('padding-right')),
      paddingBottom: parseInt(getComputedStyleParent.getPropertyValue('padding-bottom')),
      paddingLeft: parseInt(getComputedStyleParent.getPropertyValue('padding-left')),
      marginTop: parseInt(getComputedStyleParent.getPropertyValue('margin-top')),
      marginRight: parseInt(getComputedStyleParent.getPropertyValue('margin-right')),
      marginBottom: parseInt(getComputedStyleParent.getPropertyValue('margin-bottom')),
      marginLeft: parseInt(getComputedStyleParent.getPropertyValue('margin-left')),
    }
  }
}

const startObserver = (el, name) => {
  if (!name) return
  el.bcBoundingClientObserver = new ResizeObserver(() => {onResize(el, name)})
  el.bcBoundingClientObserver.observe(el)
  el.bcGetBoundingClientName = name
  onResize(el, name)
}

const stopObserver = (el) => {
  if (!el.bcBoundingClientObserver) return
  el.bcBoundingClientObserver.unobserve(el)
  el.bcBoundingClientObserver.disconnect()
}

export default {
  mounted(el, binding) {
    startObserver(el, binding.value.name)
  },
  updated(el, binding) {
    stopObserver(el, binding.value.name)
    startObserver(el, binding.value.name)
  },
  unmounted(el, binding) {
    stopObserver(el, binding.value.name)
  }
}
